import React from "react";
import { Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useState } from "react";

interface ImageUploaderProps {
  id: string;
  previewUrl?: string | null;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => void;
  setFieldValue: (field: string, value: any) => void;
  label: string;
}

const ImageUploader = ({
  id,
  previewUrl,
  onChange,
  setFieldValue,
  label,
}: ImageUploaderProps) => {
  const [imgSize, setImgSize] = useState<{
    width: number;
    height: number;
  } | null>(null);
  return (
    <Box
      sx={{
        border: "1px dashed #ccc",
        borderRadius: 1,
        p: 1,
        textAlign: "center",
        cursor: "pointer",
        "&:hover": { borderColor: "primary.main" },
      }}
    >
      <input
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        id={id}
        onChange={(e) => onChange(e, setFieldValue)}
      />
      <label htmlFor={id}>
        {previewUrl ? (
          <Box
            component="img"
            src={previewUrl}
            alt="Preview"
            onLoad={(e) => {
              const target = e.target as HTMLImageElement;
              setImgSize({
                width: target.naturalWidth,
                height: target.naturalHeight,
              });
            }}
            sx={{
              width: imgSize ? imgSize.width : undefined,
              height: imgSize ? imgSize.height : undefined,
              objectFit: "cover",
              borderRadius: 1,
              objectPosition: "top",
              // fallback if  no img is uploadd
              maxWidth: "100%",
              maxHeight: "300px",
            }}
          />
        ) : (
          <Box
            sx={{
              height: "75px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h6" color="textSecondary">
              <FormattedMessage id={label} />
            </Typography>
          </Box>
        )}
      </label>
    </Box>
  );
};

export default ImageUploader;
